(function () {

    'use strict';
    angular.module('app')
        .controller('attachAccountController', ['$scope', '$uibModalInstance', '$location', 'dashboardService', 'clientToAttach', attachAccountController]
            );

    function attachAccountController($scope, $uibModalInstance, $location, dashboardService, clientToAttach) {

        $scope.model = {};
        $scope.model.Loading = false;
        $scope.model.client = clientToAttach;

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        $scope.navigate = function () {
            //ng-href="/signup/{{model.client.name}}
            $uibModalInstance.dismiss('cancel');
            $location.url('/SignUp/' + $scope.model.client.formattedName);
        }
        $scope.submitAttach = function (client) {
            $scope.model.ErrorMessage = '';
            $scope.model.Loading = true;
            dashboardService.attachAccount(client.attachUsername,
                    client.attachPassword,
                    client.id,
                    client.attachClientDetailsId)
                .then(function (response) {


                    var item = response;
                    if (item.httpResponse.statusCode === 200) {
                        $scope.model.Loading = false;
                        $uibModalInstance.close(true);
                    } else if (item.httpResponse.statusCode === 401) {
                        // invalid
                        $scope.model.ErrorMessage = 'Your credentials are invalid. Please try again.';
                        $scope.model.Loading = false;
                    } else if (item.httpResponse.statusCode === 204) {

                        $scope.model
                            .ErrorMessage =
                            'Unfortunately your instance does not have access to this feature.  Please contact your account manager for more information.';

                        $scope.model.Loading = false;
                    } else if (item.httpResponse.statusCode === 409) {

                        if (client.id === 6 || client.id === 4) // if VCAB 
                            $scope.model
                                .ErrorMessage = 'This account has already been attached to an SSO Account.';
                        else // ELSE its gator
                            $scope.model
                                .ErrorMessage =
                                'Unfortunately your account is currently locked out due to too many failed login attempts';

                        $scope.model.Loading = false;
                    } else {
                        // error
                        $scope.model.ErrorMessage = 'An unknown error has occured.';
                        $scope.model.Loading = false;
                    }

                },
                    function () {
                        $scope.model.ErrorMessage = 'An unknown error has occured.';
                        $scope.model.Loading = false;
                    });

        };
    }
})();